import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "list-left-bottom"
};
var _hoisted_2 = {
  ref: "innerRef",
  class: "project-list"
};
var _hoisted_3 = ["title", "onClick"];
var _hoisted_4 = {
  class: "name"
};
var _hoisted_5 = ["title", "onClick"];
var _hoisted_6 = {
  class: "name sub-project"
};
import { get_projects } from "@/api/apis";
import { ref, watch, onActivated, reactive, onMounted, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  __name: 'project-item',
  props: ["list", "changeId", "type"],
  emits: ["curProjectId", "keyword"],
  setup(__props, _ref) {
    var _router$query;
    var {
      emit: __emit
    } = _ref;
    var prop = __props;
    var emits = __emit;
    var router = useRouter();
    var route = useRoute();
    var curProjectId = ref(null);
    var project_name = ref("");
    var id = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.id;
    if (id) {
      curProjectId.value = id;
    }

    // 监听路由中的 project_id 参数变化
    watch(() => {
      return route.query.project_id;
    }, val => {
      if (val) {
        curProjectId.value = parseInt(val);
        emits("curProjectId", curProjectId.value);
      }
    }, {
      immediate: true,
      deep: true
    });

    // 监听项目名称变化
    watch(() => {
      return project_name.value;
    }, (val, oldVal) => {
      if (val != oldVal) {
        emits("keyword", val);
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => {
      return prop.changeId;
    }, val => {
      if (val) {
        curProjectId.value = val;
        // 遍历包含子项目的列表
        prop.list.forEach((item, index) => {
          if (item.id === val) {
            item.isCheck = true;
          } else {
            item.isCheck = false;
          }

          // 检查子项目
          if (item.children && item.children.length > 0) {
            item.children.forEach(child => {
              if (child.id === val) {
                child.isCheck = true;
              } else {
                child.isCheck = false;
              }
            });
          }
        });
        emits("curProjectId", curProjectId.value);
      }
    }, {
      immediate: true,
      deep: true
    });

    // 切换项目 - 支持主项目和子项目
    var changeProject = function changeProject(item, parentIndex, type) {
      var childIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      curProjectId.value = item.id;
      emits("curProjectId", curProjectId.value);
      if (route.path != "/pms/task-list/index" && prop.type != "record" && prop.type != "problem" && prop.type != "role") {
        router.push({
          path: "/pms/task-list/index",
          query: {
            project_id: curProjectId.value
          }
        });
      }
    };
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["list-left", __props.type == 'problem' ? 's' : ''])
      }, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "list-left-top"
      }, [_createElementVNode("p", {
        class: "top-title"
      }, "项目列表")], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        placeholder: "请输入项目名称",
        modelValue: project_name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => project_name.value = $event),
        style: {
          "margin": "0 0 10px"
        },
        class: "search"
      }, null, 8, ["modelValue"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
        var _item$children;
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", {
          class: _normalizeClass(["item", [item.id == curProjectId.value || !curProjectId.value && index == 0 && !((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) ? 'active' : '']]),
          title: item.project_name,
          onClick: $event => changeProject(item, index, 'main')
        }, [item.status == 2 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("进行中")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 3 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 1,
          type: "success"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("已完成")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 1 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 2,
          type: "info"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("未开始")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 4 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 3,
          type: "warning"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("已暂停")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 5 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 4,
          type: "danger"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("已延期")])),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, _toDisplayString(item.project_name), 1)], 10, _hoisted_3), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: 'child-' + childIndex,
            class: "sub-item"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["item", [child.id == curProjectId.value ? 'active' : '']]),
            title: child.project_name,
            onClick: $event => changeProject(child, index, 'child', childIndex)
          }, [child.status == 2 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "primary"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("进行中")])),
            _: 1
          })) : _createCommentVNode("", true), child.status == 3 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "success"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("已完成")])),
            _: 1
          })) : _createCommentVNode("", true), child.status == 1 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: "info"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("未开始")])),
            _: 1
          })) : _createCommentVNode("", true), child.status == 4 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 3,
            type: "warning"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("已暂停")])),
            _: 1
          })) : _createCommentVNode("", true), child.status == 5 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 4,
            type: "danger"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("已延期")])),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_6, "└ " + _toDisplayString(child.project_name), 1)], 10, _hoisted_5)]);
        }), 128))]);
      }), 128))], 512)])], 2);
    };
  }
};